import type { RouteRecordRaw } from 'vue-router'

// Keep old bookmarks and the named route while sharing the workbench authorization.
export const intradayAlignmentRoute: RouteRecordRaw = {
  path: 'pcpMulti/intraday-alignment',
  name: 'IntradayPositionAlignment',
  redirect: (to) => ({
    path: '/home/pcpMulti/basis-workbench',
    query: { ...to.query, tab: 'fund-alignment' },
    hash: to.hash,
  }),
  meta: {
    title: '持仓对齐',
    requireAuth: true,
    permissions: ['pcpMulti_basis_workbench_read_update'],
  },
}
